export default __webpack_public_path__ + "static/image3-d466c2c00982ba568fb9d8f51533857d.gif";